import React from 'react';
import cn from 'classnames';

import { Menu as AntMenu, MenuProps } from 'antd';
import { AngleDownIcon } from '@revfluence/fresh-icons/solid';

import { Divider } from './Divider';
import { Item, IMenuItemProps } from './Item';
import { SubMenu, IMenuSubMenuProps } from './SubMenu';
import { ItemGroup, IMenuItemGroupProps } from './ItemGroup';

import styles from './Menu.module.scss';

export interface IMenuProps extends MenuProps {}

export type { IMenuItemProps, IMenuItemGroupProps, IMenuSubMenuProps };

export type TMenuProps = Readonly<IMenuProps>;

type TMenu = React.FC<TMenuProps> & {
  Divider: typeof Divider;
  Item: typeof Item;
  SubMenu: typeof SubMenu;
  ItemGroup: typeof ItemGroup;
};

/**
 * Menu component
 */
export const Menu: TMenu = (props) => {
  const { className, expandIcon = <AngleDownIcon />, ...restProps } = props;

  return (
    <AntMenu
      className={cn(styles.Menu, className)}
      expandIcon={expandIcon}
      {...restProps}
    />
  );
};

Menu.Divider = Divider;
Menu.Item = Item;
Menu.SubMenu = SubMenu;
Menu.ItemGroup = ItemGroup;
